import AppConstants from "../../../../../config/app.constants";
import BillableEventsBaseController from "../common/billable_events.base.controller";

class BillableEventsAllController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BillableEventsService) {
        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillableEventsService = BillableEventsService;

        this.model = {
            billableEventObj: {
                totalRecords: 0,
                eventList: [],
                loading: false
            },
            pagination: {
                page: 1,
                total: 0,
                pageLimit: 10,
                maxPages: 10
            },
            allowOnlyOnce: false,
            errorMessage: '',
            branchId: User.getUser().branchId,
            searchText: '',
            // billingCategoryObj: {
            //     TRANSPORT: 'Transport',
            //     DEPOSIT: 'Deposit',
            //     CHANGE_ORDER: 'Change Order'
            // }
        }
    }

    $onInit() {
        this.loadData();
    }

    searchObj() {
        const obj = {
            queryJSON: {
                rules: [{
                    group: {
                        rules: [{
                            field: 'type',
                            condition: 'like',
                            data: '%' + this.model.searchText + '%'
                        }],
                        operator: 'OR'
                    }
                }],
                operator: 'AND'
            }
        }
        return obj.queryJSON.rules.length ? obj : null;
    }

    loadAllEvents() {
        this.model.billableEventObj.loading = true;

        this.BillableEventsService.all(this.searchObj(), (this.model.pagination.page - 1) * this.model.pagination.pageLimit, this.model.pagination.pageLimit)
            .then((data) => {
                this.model.billableEventObj.eventList = data.results;
                this.model.billableEventObj.totalRecords = data.total;
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.billableEventObj.loading = false;
            })
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.model.pagination.page)
        this.$stateParams.page = this.model.pagination.page;
        this.$location.path(newUrl);
        this.loadAllEvents();
    }

    delete(event) {
        if (this.model.allowOnlyOnce) return;
        this.model.allowOnlyOnce = true;

        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('billableEvents.billable_event_info_message', { billingEvent: `<b>(${this.translateMessage(event.type) })</b>` }),
            callback: (({
                modal,
                $scope
            }) => {
                $scope.loading = false;
                return this.BillableEventsService.remove(event.id, event.billingCategory.name, this.translateMessage(event.type), this.model.branchId)
                    .then(() => {
                        this.loadData();
                    })
                    .catch((err) => {
                        this.Modal.errorModal(err.data.message);
                    })
                    .finally(() => {
                        this.model.allowOnlyOnce = false;
                        modal.close();
                    })
            }),
            negative: (({
                modal,
            }) => {
                this.model.allowOnlyOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

    translateMessage(key) {
        if (!key) return;
        return this.$translate.instant('entry_type.' + key);
    }

    loadData() {
        this.model.pagination.page = 1;
        this.loadAllEvents();
    }

    search() {
        this.pageChange();
    }

    edit(billableEvent) {
        this.$state.go('billable_events.edit', ({
            id: billableEvent.id
        }))
    }
}
export default BillableEventsAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/all/billable_events.all.controller.js